/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 10/21/2024
 */

import React from "react"
import Select from "react-select"
import { FormControl } from "@mui/material"

const FilterByDropdown = ({ onChange, selectRef, value }) => {
  // Selector
  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "10px",
    }),
  }

  const options = [
    {
      value: "F_TRMNL_SERIAL",
      label: "Filter by Terminal",
    },
    {
      value: "F_ORG_CODE",
      label: "Filter by Organization",
    },
    {
      value: "F_GRP_ID",
      label: "Filter by Group",
    },
  ]

  return (
    <div>
      <p
        style={{
          fontSize: "12px",
          position: "relative",
          top: "-10px",
          left: "10px",
          background: "#fff",
          width: "95px",
          paddingLeft: "5px",
          zIndex: 101,
        }}
      >
        Filter By Type
      </p>
      <FormControl
        sx={{
          minWidth: 400,
          zIndex: 100,
          position: "relative",
          top: "-36px",
          height: 0,
        }}
        size="medium"
      >
        <Select
          ref={selectRef}
          value={options.find((option) => option.value === value)}
          options={options}
          onChange={onChange}
          styles={customStyles}
          isClearable
        />
      </FormControl>
    </div>
  )
}

export default FilterByDropdown
